import React from 'react'
import { connect } from 'react-redux';
import { TrashIcon } from '@primer/octicons-react';

import { deleteCampaign } from '../../actions/campaigns';

class DeleteButton extends React.Component {
  async handleClick(event) {
    event.preventDefault();

    this.props.dispatch(deleteCampaign(this.props.campaign.uuid));
  }

  render() {
    return(
      <button onClick={this.handleClick.bind(this)}>
        <TrashIcon />
      </button>
    );
  }
}

export default connect()(DeleteButton);
